import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Header } from 'semantic-ui-react';
import { AppState } from 'services/types';

// Selectors
// @ts-ignore
import { makeSelectSharedEventValue } from '../../../../services/sharedEvent/selectors';

interface ConnectedProps {
    entityTypeName?: string;
    entityPathNames: string[];
}

type Props = ConnectedProps;

export class SharedEventGroupNameHeader extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { entityTypeName, entityPathNames } = this.props;
        if (!entityPathNames || !entityPathNames.length) return null;
        return (
            <Header sub className="shared-event-sub-header">
                {entityTypeName || 'Area'}
            </Header>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    entityTypeName: makeSelectSharedEventValue('entityTypeName'),
    entityPathNames: makeSelectSharedEventValue('entityPathNames')
});

export default connect(mapStateToProps)(SharedEventGroupNameHeader);
